import { useBooleanFlagValue } from "@openfeature/react-sdk";
export function useSelectGitRefOnCreateRelease(): boolean {
    return useBooleanFlagValue("select-git-ref-create-release", false);
}
